import React from 'react';
import {connect} from 'react-redux';
import {setCurrentLocale} from '../../../common/intl/actions';

class Language extends React.Component {

    static propTypes = {
        msg: React.PropTypes.object,
        currentLocale: React.PropTypes.string,
        setCurrentLocale: React.PropTypes.func
    };

    render() {
        const {currentLocale, setCurrentLocale, msg} = this.props;

        return (
            <div className="table-row">
              <div className="table-cell" style={{width: '55.55%'}}>
                <div className="boxBtn text-black text-left">
                    <div className="boxBtn-inner">
                      <div className="settings-name">
                        <span className="settings-name-name">{msg.settings.language.title}</span>
                      </div>
                    </div>
                </div>
              </div>
              <div className="table-cell" style={{width: '44.44%'}}>
                <div className="switch">
                    <div className={`switch-option text-l ${currentLocale === 'cs' ? 'active' : ''} color-greenLight`}
                         onClick={() => setCurrentLocale('cs')}>
                        <div className="switch-inner">
                            <span>Čeština</span>
                        </div>
                    </div>
                    <div className={`switch-option text-l ${currentLocale === 'en'  ? 'active' : ''} color-greenLight`}
                         onClick={() => setCurrentLocale('en')}>
                        <div className="switch-inner">
                            <span>English</span>
                        </div>
                    </div>
                </div>
              </div>
            </div>
        );

    }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
    currentLocale: state.intl.currentLocale
}), {setCurrentLocale})(Language);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/Language.js